import { render, staticRenderFns } from "./ReviewNextSteps.vue?vue&type=template&id=5f859c5e&scoped=true"
import script from "./ReviewNextSteps.vue?vue&type=script&lang=js"
export * from "./ReviewNextSteps.vue?vue&type=script&lang=js"
import style0 from "./ReviewNextSteps.vue?vue&type=style&index=0&id=5f859c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f859c5e",
  null
  
)

export default component.exports